import React, { useState } from 'react';
/* 🎯 1. IMPORT THE GENERIC CONTROLS */
import { DisplayToggleControl, AddEntryControl } from '../../../common/components/SEC_UI_StatusControls';

const SEC_03_CapabilityManagementView = ({ capabilities = [], onUpdate, onAdd }) => {
    const [newRow, setNewRow] = useState({
        capabilityCode: '',
        capabilityName: '',
        description: '',
        isActive: false // Starts hidden
    });

    const handleAddSubmit = () => {
        onAdd(newRow);
        setNewRow({ capabilityCode: '', capabilityName: '', description: '', isActive: false });
    };

    return (
        <div className="table-responsive">
            <table className="table table-hover align-middle">
                <thead className="table-light">
                    <tr>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th className="text-end pe-3">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {capabilities.length === 0 ? (
                        <tr>
                            <td colSpan="5" className="text-center text-muted fst-italic py-3">
                                No capabilities available. Please add one below.
                            </td>
                        </tr>
                    ) : (
                        capabilities.map((cap) => (
                            <tr key={cap.capabilityId}>
                                <td>{cap.capabilityCode}</td>
                                <td>{cap.capabilityName}</td>
                                <td>{cap.description}</td>
                                
                                {/* 🎯 2. APPLY TOGGLE CONTROL */}
                                <DisplayToggleControl 
                                    isActive={cap.isActive} 
                                    onToggle={() => onUpdate(cap.capabilityId, { isActive: !cap.isActive })} 
                                    entityName="capability"
                                />
                            </tr>
                        ))
                    )}

                    <tr className="bg-light">
                        <td>
                            <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="e.g. EXPORT" 
                                value={newRow.capabilityCode}
                                onChange={(e) => setNewRow({ ...newRow, capabilityCode: e.target.value.toUpperCase() })}
                            />
                        </td>
                        <td>
                            <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="Capability Name" 
                                value={newRow.capabilityName}
                                onChange={(e) => setNewRow({ ...newRow, capabilityName: e.target.value })}
                            />
                        </td>
                        <td>
                            <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="Short description..." 
                                value={newRow.description}
                                onChange={(e) => setNewRow({ ...newRow, description: e.target.value })}
                            />
                        </td>

                        {/* 🎯 3. APPLY ADD CONTROL */}
                        <AddEntryControl 
                            onAdd={handleAddSubmit} 
                            entityName="capability"
                        />
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default SEC_03_CapabilityManagementView;